import { render, staticRenderFns } from "./bindUser.vue?vue&type=template&id=1ffe329e&"
import script from "./bindUser.vue?vue&type=script&lang=js&"
export * from "./bindUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports